import { Tooltip as MuiTooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import { InfoCircleFill } from '@styled-icons/bootstrap/InfoCircleFill';
import CommunicationIcon from 'assets/img/icons/communication.svg';
import ThemeTypography from 'DesignSystem/Primitives/Typography/ThemeTypography';
import React, { ReactNode } from 'react';
import { EAvailableSizes } from 'DesignSystem/types/size.types';

const Icon = styled('div')(({ theme }) => ({
  color: theme.palette.grey[500],
  margin: theme.spacing(0, 1),
  cursor: 'pointer',
  alignItems: 'center',
  display: 'flex',
}));

/**
 * Since the tooltip gets attached to the body, we need to use with styles to style it
 */
const StyledTooltip = withStyles(theme => ({
  tooltip: {
    background: theme.palette.common.white,
    borderRadius: 4,
    padding: theme.spacing(2),
    fontWeight: 500,
    boxShadow: '0 0 8px 4px rgba(0, 0, 0, 0.1)',
    color: theme.custom.themeColors.black,
    maxWidth: 500,
  },
}))(MuiTooltip);

const HintIcon = styled('img')<{ size: number }>(({ size }) => ({
  width: size + 4,
  pointerEvents: 'none',
}));

export type TooltipVariant = 'INFO' | 'HINT';

interface IProps {
  text: string | ReactNode;
  className?: string;
  size?: EAvailableSizes;
  headline?: string;
  variant?: TooltipVariant;
}

const InfoTooltip: React.FC<IProps> = ({
  className,
  text,
  headline,
  size = EAvailableSizes.SMALL,
  variant = 'INFO',
}) => {
  return (
    <StyledTooltip
      title={
        <>
          {headline && <ThemeTypography variant="BODY_LARGE_BOLD">{headline}</ThemeTypography>}
          {typeof text === 'string' ? (
            <ThemeTypography variant="BODY_MEDIUM" color="GRAY">
              {text}
            </ThemeTypography>
          ) : (
            text
          )}
        </>
      }
      placement="right"
    >
      <Icon className={className}>
        {variant === 'INFO' ? (
          <InfoCircleFill size={getIconSize(size)} />
        ) : (
          <HintIcon size={getIconSize(size)} src={CommunicationIcon} />
        )}
      </Icon>
    </StyledTooltip>
  );
};

export default InfoTooltip;

const getIconSize = (size: EAvailableSizes) => {
  switch (size) {
    case EAvailableSizes.SMALL:
      return 12;
    case EAvailableSizes.MEDIUM:
      return 14;
    case EAvailableSizes.LARGE:
      return 16;
    default:
      return 12;
  }
};
